import { useCallback, useState } from 'react';

import useFetch from 'hooks/useFetch';
import useRetry from 'hooks/useRetry';

import useTranslation from './hooks/useTranslation';

import { CHEMICAL_DB_API_HOST, COMPATIBILITY_ADVISORY_API, JSON_HEADERS } from './constants';
import type { CompatibilityAdvisoryResponse, FetchCompatibilityAdvisory } from './types';

const useCompatibilityAdvisory = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { authenticatedPost } = useFetch({
        apiHost: CHEMICAL_DB_API_HOST,
        headers: JSON_HEADERS
    });
    const { withRetry } = useRetry();
    const { CONNECTION_ERROR } = useTranslation();

    const fetch: FetchCompatibilityAdvisory = useCallback(
        async ({ request }) => {
            try {
                setIsLoading(true);

                return await withRetry(
                    () =>
                        authenticatedPost<CompatibilityAdvisoryResponse>(
                            COMPATIBILITY_ADVISORY_API,
                            JSON.stringify(request)
                        ),
                    CONNECTION_ERROR,
                    () => fetch({ request })
                );
            } finally {
                setIsLoading(false);
            }
        },
        [authenticatedPost, withRetry, CONNECTION_ERROR]
    );

    return { fetch, isLoading };
};

export default useCompatibilityAdvisory;
